import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import { Menu, BookOpen, Compass } from "lucide-react";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const scrollToTools = () => {
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollToTools: true } });
    } else {
      document.getElementById('tools')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToResources = () => {
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollToResources: true } });
    } else {
      document.getElementById('resources')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleHomeClick = () => {
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  const articleCategories = [
    {
      title: "Foundational Concepts",
      href: "/foundational-concepts",
    },
    {
      title: "Journey and Stages",
      href: "/journey-stages",
    },
    {
      title: "Signs and Connections",
      href: "/signs-connections",
    },
    {
      title: "Spiritual and Esoteric Aspects",
      href: "/spiritual-esoteric",
    },
  ];

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Button
              variant="ghost"
              size="icon"
              className="md:hidden"
              onClick={() => {}}
            >
              <Menu className="h-5 w-5" />
            </Button>
            <button
              onClick={handleHomeClick}
              className="text-xl font-serif text-gray-900 hover:text-purple-600 transition-colors"
            >
              Twin Flames
            </button>
          </div>
          
          <div className="hidden md:flex items-center space-x-4">
            <Button
              variant="ghost"
              onClick={handleHomeClick}
              className="text-gray-600 hover:text-purple-600"
            >
              Home
            </Button>
            
            <Button
              variant="ghost"
              onClick={scrollToTools}
              className="text-gray-600 hover:text-purple-600"
            >
              Tools
            </Button>

            <Button
              variant="ghost"
              onClick={scrollToResources}
              className="text-gray-600 hover:text-purple-600"
            >
              <Compass className="h-4 w-4 mr-2" />
              Resources
            </Button>

            <NavigationMenu>
              <NavigationMenuList>
                <NavigationMenuItem>
                  <NavigationMenuTrigger className="text-gray-600 hover:text-purple-600">
                    <BookOpen className="h-4 w-4 mr-2" />
                    Articles
                  </NavigationMenuTrigger>
                  <NavigationMenuContent>
                    <ul className="grid w-[400px] gap-3 p-4">
                      {articleCategories.map((category) => (
                        <li key={category.title}>
                          <NavigationMenuLink asChild>
                            <a
                              href={category.href}
                              className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                            >
                              <div className="text-sm font-medium leading-none">
                                {category.title}
                              </div>
                            </a>
                          </NavigationMenuLink>
                        </li>
                      ))}
                    </ul>
                  </NavigationMenuContent>
                </NavigationMenuItem>
              </NavigationMenuList>
            </NavigationMenu>
          </div>
        </div>
      </div>
    </nav>
  );
};